/**
 * Requests from PD to marketing (#1113): artwork, a label, CAD, photos or
 * video, on a product or on none, so nobody has to invent a fake product to
 * get an Asana task (the BF-220 label: seven weeks, 20 emails).
 *
 * Decided (David, 2026-09-26): an ATLAS queue (Marketing → Requests), plus an
 * optional Asana task in an admin-configured project, made by the service
 * account. Files go to SharePoint like every other upload. The brand's
 * marketing people are notified; one claims it. Any internal user may ask.
 *
 * Two-way: the PD_REQUEST_TYPES ask PD instead (marketing needs specs, a
 * sample, photometrics or a sign-off). They need a product; its PM and watchers
 * are notified and any internal writer may claim.
 */
import { navFeatureId } from './feature-visibility.js';
export const MARKETING_REQUEST_TYPES = [
    'artwork', 'label', 'cad', 'photo', 'video', 'other',
    // Asks the other way, marketing → PD. Direction is derived from the type, not stored.
    'specs', 'sample', 'photometrics', 'sign_off',
];
/** The types that ask PD for something: always on a product, rung to its PM and watchers. */
export const PD_REQUEST_TYPES = ['specs', 'sample', 'photometrics', 'sign_off'];
/** True when the request is addressed to PD rather than to marketing. */
export const isRequestToPd = (type) => PD_REQUEST_TYPES.includes(type);
export const MARKETING_REQUEST_TYPE_LABELS = {
    artwork: 'Artwork',
    label: 'Label',
    cad: 'CAD',
    photo: 'Photos',
    video: 'Video',
    other: 'Other',
    specs: 'Specs',
    sample: 'Samples',
    photometrics: 'Photometrics',
    sign_off: 'Sign-off',
};
export const MARKETING_REQUEST_STATUSES = ['open', 'in_progress', 'done', 'cancelled'];
/** Statuses a request can't leave, and that take no more files. */
export const MARKETING_REQUEST_FINAL_STATUSES = ['done', 'cancelled'];
export const MARKETING_REQUEST_STATUS_LABELS = {
    open: 'Open',
    in_progress: 'In progress',
    done: 'Done',
    cancelled: 'Cancelled',
};
export const MARKETING_REQUESTS_PATH = '/marketing/requests';
export const MARKETING_REQUESTS_FEATURE = navFeatureId(MARKETING_REQUESTS_PATH);
//# sourceMappingURL=marketing-request.js.map